import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/userSlice";
import { fetchSignageBranches } from "../../../views/Signage/signageApi";
import WidgetFrame, { WidgetEmpty, WidgetStat } from "./WidgetFrame";

// Signage fleet at a glance (Admin/Executive Team see every branch, a GM
// sees their own — the API scopes by the x-user-id header): how many
// displays are up right now, out of how many, across how many branches.
const SignageWidget = () => {
  const user = useSelector(selectUser);
  const [branches, setBranches] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!user?.id) return;
    fetchSignageBranches(user.id)
      .then(setBranches)
      .catch(() => setFailed(true));
  }, [user?.id]);

  if (!branches) {
    return (
      <WidgetFrame title="Digital Signage" to="/signage">
        <WidgetEmpty>
          {failed ? "Couldn't load signage status." : "Loading displays…"}
        </WidgetEmpty>
      </WidgetFrame>
    );
  }

  const devices = branches.reduce((sum, b) => sum + (b.deviceCount || 0), 0);
  const online = branches.reduce((sum, b) => sum + (b.onlineCount || 0), 0);
  const offline = devices - online;

  return (
    <WidgetFrame title="Digital Signage" to="/signage">
      {devices === 0 ? (
        <WidgetEmpty>No displays registered yet.</WidgetEmpty>
      ) : (
        <>
          <div className="grid grid-cols-3 gap-2">
            <WidgetStat value={online} label="Online" />
            <WidgetStat value={offline} label="Offline" />
            <WidgetStat value={branches.length} label="Branches" />
          </div>
          {offline > 0 && (
            <p className="app-muted mt-2 truncate text-xs">
              Offline at:{" "}
              {branches
                .filter((b) => (b.deviceCount || 0) > (b.onlineCount || 0))
                .map((b) => b.name)
                .join(", ")}
            </p>
          )}
        </>
      )}
    </WidgetFrame>
  );
};

export default SignageWidget;
